import type { ComponentPropsWithoutRef, ReactNode } from 'react'
import './Checkbox.css'

export interface CheckboxProps extends Omit<ComponentPropsWithoutRef<'input'>, 'type'> {
  label: ReactNode
}

/**
 * Case à cocher avec une cible tactile de 44 px : c'est le `<label>` entier
 * qui est cliquable, pas seulement le carré de 20 px — indispensable pour un
 * public non technique sur écran tactile. (Le liseré pointillé de la
 * maquette n'est qu'une annotation mesurant cette zone ; il n'existe pas ici.)
 */
export function Checkbox({ label, className, disabled, ...rest }: CheckboxProps) {
  const classes = ['azoya-checkbox', disabled && 'is-disabled', className].filter(Boolean).join(' ')
  return (
    <label className={classes}>
      <input {...rest} type="checkbox" disabled={disabled} />
      <span className="azoya-checkbox-label">{label}</span>
    </label>
  )
}
